import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import {extractErrorMessage, goToNextPage} from 'src/app/common/common';
import { SchedulerTask } from 'src/app/model/scheduler.model';
import { AuthService } from 'src/app/services/auth.service';
import { ApiService } from 'src/app/services/api.service';
import { FormsModule } from '@angular/forms';
import {PaginationClass, PaginationModel} from "../../../../common/pagination";

@Component({
  selector: 'app-scheduler-index',
  standalone: true,
  imports: [RouterModule, CommonModule, NgxPaginationModule, FormsModule],
  templateUrl: './scheduler-index.component.html',
  styleUrl: './scheduler-index.component.scss'
})
export class SchedulerIndexComponent implements OnInit {
  public isAdmin: boolean = false;
  public displayedTasks: SchedulerTask[] = [];

  public router: Router;
  public error: string | null = null;

  protected readonly paginationId = 'schedulerPagination';
  private pagination = new PaginationClass(this.paginationId);
  protected paginationModel: PaginationModel = this.pagination.getPaginationModel();

  constructor(private injector: Injector, private authService: AuthService, private schedulerService: ApiService) {
    this.router = injector.get(Router);
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin();
    this.loadTasks();
  }

  loadTasks(): void {
    this.schedulerService.getSchedulerTasks({ depth: 1 }).subscribe({
      next: (response: SchedulerTask[]) => {
        this.displayedTasks = response.reverse();
      },
      error: (err) => {
        console.error(err);
        this.error = extractErrorMessage(err, "Failed to load Scheduler's tasks.");
      }
    });
  }

  nextPage(event: any, url: string, router: Router) {
    return goToNextPage(event, url, router);
  }

  delete(scheduler: any) {
    if (confirm('Are you sure you want to delete this scheduler-index task?')) {
      this.schedulerService.deleteSchedulerTasks(scheduler?.name).subscribe({
        next: () => {
          this.loadTasks(); // Reload the tasks after deletion
        },
        error: (err) => {
          console.error(err);
          this.error = extractErrorMessage(err, 'Unable to delete this scheduler-index task');
        }
      });
    }
  }

  handlePageChange(newPage: number) {
    this.paginationModel = this.pagination.changePage(newPage);
    this.loadTasks();
  }
}
